import { Component, OnInit, HostListener } from '@angular/core';
import { Router } from '@angular/router';
import { ChecklistService } from './../../../shared/services/checklist.service';
import { ActiveUserLocalDataService } from './../../../shared/services/active-user-local-data.service';
import {
  GetCheckListForClientRequest,
  GetCheckListForClientResponse,
  CheckListForClientModel,
  PostCheckListAnswerRequest,
} from './../../../shared/models/checklist.models';

@Component({
  templateUrl: 'checklist.component.html',
  styleUrls: ['./checklist.component.scss'],
})
export class ChecklistComponent implements OnInit {
  checklistResponse: GetCheckListForClientResponse | null = null;
  textareaTextDict: { [key: string]: string } = {};
  imageDict: { [key: string]: Uint8Array } = {};
  errorMessage: string = '';
  popupVisibleError: boolean = false;
  isPopupVisible = false;
  isMobile: boolean = false;
  loading: boolean = false;
  selectedItems: CheckListForClientModel[] = [];
  flag: boolean = true;

  constructor(
    private checklistService: ChecklistService,
    private activeUserLocalDataService: ActiveUserLocalDataService,
    private router: Router
  ) {}

  ngOnInit() {
    this.checkIfMobile();
    this.loadChecklist();
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this.checkIfMobile();
  }

  private checkIfMobile() {
    this.isMobile = window.innerWidth <= 768;
  }

  loadChecklist() {
    this.loading = true;
    const startNewVoucherData = this.activeUserLocalDataService.getStartNewVoucherData();
    if (!startNewVoucherData) {
      this.router.navigate(['/pick-car']);
      return;
    }
    const request: GetCheckListForClientRequest = {
      clientId: startNewVoucherData.clientId,
      carId: startNewVoucherData.carId,
    };
    this.checklistService.getCheckListForClient(request).subscribe((response: GetCheckListForClientResponse) => {
      this.checklistResponse = response;
      console.log('[CHECKLIST] carId:', startNewVoucherData.carId, '| API atbilde:', JSON.stringify(response?.checkList?.map(i => ({
        id: i.id, q: i.questionText,
        octaIsActive: i.octaIsActive, octaValidTo: i.octaValidTo, nextOctaValidFrom: i.nextOctaValidFrom,
        tehInspection: i.tehInspectionExpDate, roadLv: i.roadTaxLvValidTo, roadLt: i.roadTaxLtValidTo
      })), null, 2));
      if (!this.checklistResponse || !this.checklistResponse.checkList || this.checklistResponse.checkList.length === 0) {
    
        this.router.navigate(['/input-odometer']);
      } else {
        
      }
      if (this.checklistResponse?.checkList) {
        this.checklistResponse.checkList.forEach((item) => {
          if (item.allowInputComment) {
            this.textareaTextDict[item.id.toString()] = '';
          }
        });
        this.selectedItems = [...this.checklistResponse.checkList];
      }
      this.updateChecklistItemStyles();
      this.loading = false;
    });
  }

  continueClicked() {
    let allQuestionsAnswered = true;
    let allImagesProvided = true;
  
    this.checklistResponse?.checkList.forEach(item => {
      const [isAnswered, isImageProvided] = this.checkQuestionCompletion(item);
  
      if (!isAnswered) {
        allQuestionsAnswered = false;
      }
  
      if (!isImageProvided) {
        allImagesProvided = false;
      }
  
      if (!allQuestionsAnswered || !allImagesProvided) {
        return;
      }
    });
  
    if (allQuestionsAnswered && allImagesProvided) {
      this.saveChecklistData();
      this.router.navigate(['/input-odometer']);
    } else {
      if (!allQuestionsAnswered && !allImagesProvided) {
        this.errorMessage = "Lūdzu atbildiet uz visiem jautājumiem un pievienojiet trūkstošos attēlus!";
      } else if (!allQuestionsAnswered) {
        this.errorMessage = "Lūdzu atbildiet uz visiem jautājumiem!";
      } else if (!allImagesProvided) {
        this.errorMessage = "Lūdzu pievienojiet trūkstošos attēlus!";
      }
  
      this.popupVisibleError = true;
    }
  }

  saveChecklistData() {
    const startNewVoucherData =
        this.activeUserLocalDataService.getStartNewVoucherData();
    if (startNewVoucherData && this.checklistResponse?.checkList) {
        startNewVoucherData.checklistAnswers =
            this.checklistResponse.checkList.map((item) => ({
                checklistQuestionId: item.id,
                checklistAnswer: item.selectedAnswer,
                comment: this.textareaTextDict[item.id.toString()] || '',
                image: this.imageDict[item.id.toString()] || new Uint8Array(),
            }));
    }
}

checkQuestionCompletion(item: CheckListForClientModel): [boolean, boolean] {
  const isAnswered = item.possibleAnswers ? item.possibleAnswers.includes(item.selectedAnswer) : false;
  const isImageProvided = !item.mandatoryImage || !!this.imageDict[item.id.toString()];
  return [isAnswered, isImageProvided];
}

isChecklistItemCompleted(item: CheckListForClientModel): boolean {
  const [isAnswered, isImageProvided] = this.checkQuestionCompletion(item);
  return isAnswered && isImageProvided;
}

updateChecklistItemStyles() {
  if (this.checklistResponse?.checkList) {
    this.checklistResponse.checkList.forEach((item, index) => {
      const accordionElement = document.querySelector('.dx-accordion');
      const itemElement = accordionElement?.querySelectorAll('.dx-accordion-item')[index];
      if (itemElement) {
        if (this.isChecklistItemCompleted(item)) {
          itemElement.classList.add('completed');
          itemElement.classList.remove('incomplete');
        } else {
          itemElement.classList.add('incomplete');
          itemElement.classList.remove('completed');
        }
      }
    });
  }
}

toggleAccordionStyle() {
  const accordionElement = document.querySelector('.dx-accordion');
  if (accordionElement) {
    accordionElement.classList.toggle('custom-style');
  }
}

  // Returns true when current period expires today/yesterday but next period starts tomorrow or today
  isExpiringButNextStarts(validTo: Date | undefined, nextPeriodStart: Date | undefined): boolean {
    if (!validTo || !nextPeriodStart) return false;
    const today = new Date(); today.setHours(0, 0, 0, 0);
    const end = new Date(validTo); end.setHours(0, 0, 0, 0);
    const next = new Date(nextPeriodStart); next.setHours(0, 0, 0, 0);
    const daysDiff = (end.getTime() - today.getTime()) / (1000 * 3600 * 24);
    const gapDays = (next.getTime() - end.getTime()) / (1000 * 3600 * 24);
    // expires today (daysDiff===0) or recently, and next starts within 1 day gap
    return daysDiff <= 0 && daysDiff >= -1 && gapDays <= 1;
  }

  isDateExpired(date: Date | undefined): boolean {
    if (!date) return true;
    const today = new Date(); today.setHours(0, 0, 0, 0);
    const d = new Date(date); d.setHours(0, 0, 0, 0);
    return d.getTime() < today.getTime();
  }

  getDateCssClass(date: Date | undefined, nextPeriodStart?: Date | undefined): string {
    const todayDbg = new Date(); todayDbg.setHours(0,0,0,0);
    const nextStr = nextPeriodStart ? new Date(nextPeriodStart).toISOString().slice(0,10) : 'nav';
    if (!date) {
      if (nextPeriodStart) {
        const next = new Date(nextPeriodStart);
        next.setHours(0, 0, 0, 0);
        const today = new Date(); today.setHours(0, 0, 0, 0);
        if (next <= today) { console.log(`[DATE] nav datuma, nākamais=${nextStr} jau sācies → date-valid`); return 'date-valid'; }
        console.log(`[DATE] nav datuma, nākamais=${nextStr} vēl nesācies → date-warning`);
        return 'date-warning';
      }
      console.log('[DATE] nav datuma, nav nākamā → date-invalid');
      return 'date-invalid';
    }
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const inputDate = new Date(date);
    inputDate.setHours(0, 0, 0, 0);
    const daysDifference = (inputDate.getTime() - today.getTime()) / (1000 * 3600 * 24);
    const dateStr = inputDate.toISOString().slice(0,10);
    console.log(`[DATE] validTo=${dateStr}(local:${date}) | šodien=${todayDbg.toISOString().slice(0,10)} | starpība=${daysDifference}d | nākamais=${nextStr}`);
    if (daysDifference < 0) {
      if (nextPeriodStart) {
        const next = new Date(nextPeriodStart);
        next.setHours(0, 0, 0, 0);
        if (next <= today) { console.log(`[DATE] beidzies, nākamais jau sācies → date-valid`); return 'date-valid'; }
        console.log(`[DATE] beidzies, nākamais=${nextStr} vēl nesācies → date-warning`);
        return 'date-warning';
      }
      console.log('[DATE] beidzies, nav nākamā → date-invalid');
      return 'date-invalid';
    } else if (daysDifference <= 10) {
      if (nextPeriodStart) {
        const next = new Date(nextPeriodStart);
        next.setHours(0, 0, 0, 0);
        const gapDays = (next.getTime() - inputDate.getTime()) / (1000 * 3600 * 24);
        if (gapDays <= 1) { console.log(`[DATE] ≤10d, nākamais secīgi vai rīt (gap=${gapDays}d) → date-warning (oranžs, zaļš info zemāk)`); return 'date-warning'; }
        console.log(`[DATE] ≤10d, nākamais=${nextStr} gap=${gapDays}d → date-warning`);
      } else {
        console.log(`[DATE] ≤10d, nav nākamā → date-warning`);
      }
      return 'date-warning';
    } else {
      console.log(`[DATE] ${daysDifference}d atlikuši → date-valid`);
      return 'date-valid';
    }
  }

  calculateRemainingDays(endDate: Date | undefined): number {
    if (!endDate) {
      return 0;
    }
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const end = new Date(endDate);
    end.setHours(0, 0, 0, 0);
    const remainingDays = Math.ceil(
      (end.getTime() - today.getTime()) / (1000 * 3600 * 24)
    );
    return remainingDays > 0 ? remainingDays : 0;
  }

  onContentReady(e: any) {
    if (this.flag && this.checklistResponse?.checkList) {
      for (let i = 0; i < this.checklistResponse.checkList.length; i++) {
        e.component.expandItem(i);
      }
      this.flag = false;
    }
  }

  navigateToPickClient() {
    this.router.navigate(['/pick-client']);
  }

  async onFileUploaderValueChanged(event: any, checklistItemId: number) {
    const file = event.value[0];
    if (file) {
        const reader = new FileReader();
        reader.onload = async () => {
            const arrayBuffer = reader.result as ArrayBuffer;
            const image = new Uint8Array(arrayBuffer);

            const resizedImage = await this.resizeImage(image);

            this.imageDict[checklistItemId.toString()] = resizedImage;

            const checklistItem = this.checklistResponse?.checkList.find(item => item.id === checklistItemId);
            if (checklistItem) {
                const [isAnswered, isImageProvided] = this.checkQuestionCompletion(checklistItem);
                this.updateChecklistItemStyles();
            }
        };
        reader.readAsArrayBuffer(file);
    }
}

arrayBufferToBase64(buffer: Uint8Array): string {
  let binary = '';
  const bytes = new Uint8Array(buffer);
  const len = bytes.byteLength;
  for (let i = 0; i < len; i++) {
      binary += String.fromCharCode(bytes[i]);
  }
  return window.btoa(binary);
}
  
  async resizeImage(image: Uint8Array): Promise<Uint8Array> {
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');
  
    if (!ctx) {
      throw new Error('Failed to get 2D context');
    }
  
    const img = new Image();
  
    return new Promise((resolve, reject) => {
      img.onload = () => {
        const maxSize = 1024;
        let width = img.width;
        let height = img.height;
  
        if (width > height) {
          if (width > maxSize) {
            height *= maxSize / width;
            width = maxSize;
          }
        } else {
          if (height > maxSize) {
            width *= maxSize / height;
            height = maxSize;
          }
        }
  
        canvas.width = width;
        canvas.height = height;
        ctx.drawImage(img, 0, 0, width, height);
  
        canvas.toBlob((blob) => {
          if (blob) {
            const reader = new FileReader();
            reader.onload = () => {
              resolve(new Uint8Array(reader.result as ArrayBuffer));
            };
            reader.onerror = reject;
            reader.readAsArrayBuffer(blob);
          } else {
            reject(new Error('Failed to create blob from canvas'));
          }
        }, 'image/jpeg');
      };
      img.onerror = reject;
      img.src = URL.createObjectURL(new Blob([image]));
    });
  }

  removeFile(checklistItemId: number) {
    delete this.imageDict[checklistItemId.toString()];
  }

  onAnswerChange(checklistItem: CheckListForClientModel) {
    this.updateChecklistItemStyles();
  }
}